/* eslint-disable @typescript-eslint/no-explicit-any */
import type { FilterFn } from '@tanstack/react-table';

export const customArrayIncludesSome: FilterFn<any> = (
  row,
  columnId: string,
  filterValue: unknown[],
) => {
  if (!filterValue) {
    return true;
  }

  const rowValue = row.getValue<unknown[]>(columnId);

  // Handle both single values and arrays
  // as when one value is selected, it is a string.
  return Array.isArray(filterValue)
    ? filterValue.includes(rowValue)
    : rowValue === filterValue;
};
